import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    padding: '1rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 50px)',
    minHeight: '300px',
    overflow: 'hidden',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'center'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'end',
    padding: '0 0 10px'
  },
  filters: {
    display: 'flex',
    gap: '1rem'
  },
  tableWrapper: {
    overflow: 'auto',
    width: '100%',
    display: 'flex',
    flex: 1
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    '& thead th': {
      backgroundColor: theme.palette.gray.light,
      padding: '8px',
      borderBottom: `1px solid ${theme.palette.gray.darker}`,
      textAlign: 'left',
      color: 'rgba(0,0,0,0.5)',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      lineHeight: '19px',
      minWidth: 'fit-content',
      '&.required': {
        fontWeight: '400',
        fontFamily: theme.typography.families.bold,
        color: 'rgba(0,0,0,1)'
      }
    },
    '& tbody': {
      overflow: 'scroll'
    },
    '& tr': {
      '&.__selected': {
        background: theme.palette.success.A50
      }
    },
    '& td': {
      border: `1px solid ${theme.palette.gray.main}`,
      minWidth: 'fit-content',
      padding: '8px'
    }
  }
}))
